import type { SVGProps } from "react";
export interface UsersGroupIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function UsersGroupIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: UsersGroupIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M3.122 15.001a1.125 1.125 0 0 1 1.141 1.94 2.3 2.3 0 0 0-1.072 1.451 1.125 1.125 0 0 1-.076 2.227L3 20.625h-.429c-.937 0-1.696-.76-1.696-1.697 0-1.674.905-3.137 2.247-3.927M19.375 7.5a1.87 1.87 0 0 0-.71-1.47l-.196-.136-.096-.064a1.126 1.126 0 0 1 1.16-1.915l.1.054.22.142a4.124 4.124 0 0 1-.218 6.92l-.102.055a1.126 1.126 0 0 1-1.064-1.98l.195-.136a1.87 1.87 0 0 0 .71-1.47Zm-17 0c0-1.502.804-2.815 1.998-3.535a1.125 1.125 0 0 1 1.162 1.928 1.873 1.873 0 0 0-.2 3.076l.195.136.095.065a1.125 1.125 0 0 1-1.158 1.914l-.103-.054-.218-.142A4.12 4.12 0 0 1 2.375 7.5m20.75 11.428c0 .937-.76 1.697-1.697 1.697H21a1.125 1.125 0 0 1-.191-2.233 2.3 2.3 0 0 0-.824-1.283l-.244-.166-.097-.064a1.125 1.125 0 0 1 1.138-1.926l.103.053.246.156a4.55 4.55 0 0 1 1.994 3.766m-11.839-2.803a3.16 3.16 0 0 0-3.132 2.75h7.692a3.16 3.16 0 0 0-3.132-2.75zm3.09-8.625a2.376 2.376 0 1 0-4.752.002 2.376 2.376 0 0 0 4.752-.002m3.75 11.786a1.84 1.84 0 0 1-1.84 1.84H7.715a1.84 1.84 0 0 1-1.84-1.84 5.41 5.41 0 0 1 5.411-5.412h1.428a5.41 5.41 0 0 1 5.411 5.412ZM16.625 7.5a4.626 4.626 0 1 1-9.25 0 4.626 4.626 0 0 1 9.25 0"
      />
    </svg>
  );
}
